import * as Yup from 'yup';

export const TermsValidationSchema = Yup.object().shape({
    terms: Yup.array().of(
        Yup.object().shape({
            value: Yup.string().required('app.error.required'),
        })
    ),
});
